import { render, staticRenderFns } from "./serviceItemsP.vue?vue&type=template&id=b2977ac2"
import script from "./serviceItemsP.vue?vue&type=script&lang=js"
export * from "./serviceItemsP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports